import React from 'react';

import auth from '../Database/Auth';
import db from '../Database/Database';

import destiyDiff from './DestinyDiff'

function setDestinyTokens(tokens) {
  var outcome = destiyDiff(db.getDestinyTokens(), tokens);
  if (outcome) {
    db.sendResult({
      room: db.getRoom(),
      user: auth.getUser(),
      type: 'MESSAGE',
      message: `${outcome} Destiny`
    });
  }
  db.setDestinyTokens(tokens);
}


export default () => {
  var destinyTokens = db.getDestinyTokens() || [];

  var tokenPos = 0;

  var onAdd = () => {
    setDestinyTokens([...destinyTokens, 'white'])
  }

  var onRemove = () => {
    setDestinyTokens(destinyTokens.slice(0, -1))
  }

  var swapToken = tokenPos => {
    setDestinyTokens([
      ...destinyTokens.slice(0, tokenPos),
      destinyTokens[tokenPos] === 'black' ? 'white' : 'black',
      ...destinyTokens.slice(tokenPos+1)
    ])
  }

  var tokenImgStyle = {
    width:  36,
    height: 36
  }

  var addRmBtnStyle = {
    display: 'block',
    padding: '0 4px',
    height: 18,
    lineHeight: '18px'
  }

  return <div style={{minHeight: 40}} className="DestinyContainer">

    <div style={{float: 'left', paddingLeft: 6}}>
      <button style={{...addRmBtnStyle, marginBottom: 3}} onClick={onAdd}>⬆</button>
      <button style={addRmBtnStyle} onClick={onRemove}>⬇</button>
    </div>

    <div style={{marginLeft: 36}}>
      {destinyTokens.map(tokenState=>
        <span
          className="destinyToken"
          onClick={swapToken.bind(null, tokenPos)}
          key={tokenPos++}>
            <img
              style={tokenImgStyle}
              src={`/destinyTokens/${tokenState}.png`}
              alt={tokenState} />
        </span>
      )}
    </div>
  </div>
}


// WEBPACK FOOTER //
// ./src/DestinyContainer/DestinyContainer.js